import "./styles.scss";

import moment from "moment";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { ReactComponent as ArrowIcon } from "assets/icons/new/calendar-arrow.svg";

const mainClass = "calendar-days";

const CalendarDays = ({
  date,
  setDate,
  selected_date,
  prev_date,
  next_date,
  onSelect,
  onBack,
}) => {
  const { t } = useTranslation();

  const temp_date = moment(date)?.set("date", 1);
  const today = moment().startOf("day");

  const dayNames = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

  let all_days = [];
  let firstDayIndex = temp_date.day();
  firstDayIndex = firstDayIndex === 0 ? 6 : firstDayIndex - 1;

  if (firstDayIndex > 0) {
    const prevMonth = moment(temp_date).subtract(1, "month");
    const daysInPrevMonth = prevMonth.daysInMonth();

    for (let i = 0; i < firstDayIndex; i++) {
      const d = moment(prevMonth).set(
        "date",
        daysInPrevMonth - firstDayIndex + i + 1
      );
      all_days.push({
        date: d.format("ll"),
        day: d.format("D"),
        isPrevMonth: true,
        isToday: d.isSame(today, "day"),
        disabled: true,
      });
    }
  }

  for (let i = 0; i < temp_date?.daysInMonth(); i++) {
    const d = moment(temp_date).add(i, "days");

    all_days.push({
      date: d.format("ll"),
      day: d.format("D"),
      isToday: d.isSame(today, "day"),
      disabled: !!prev_date
        ? moment(prev_date).isAfter(d)
        : !!next_date
        ? moment(next_date).isBefore(d)
        : false,
    });
  }

  const totalDaysToShow = 35;
  const remainingDays =
    totalDaysToShow +
    (all_days.length > totalDaysToShow
      ? 7
      : firstDayIndex === 0 && all_days.length === 28
      ? -7
      : 0) -
    all_days.length;

  if (remainingDays > 0) {
    const nextMonth = moment(temp_date).add(1, "month");

    for (let i = 0; i < remainingDays; i++) {
      const d = moment(nextMonth).set("date", i + 1);
      all_days.push({
        date: d.format("ll"),
        day: d.format("D"),
        isNextMonth: true,
        isToday: d.isSame(today, "day"),
        disabled: true,
      });
    }
  }

  const onChangeMonth = (type) => {
    if (type === "prev") {
      setDate((prev) => moment(prev).add(-1, "months"));
    } else {
      setDate((prev) => moment(prev).add(1, "months"));
    }
  };

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__header`}>
        <button
          className={`${mainClass}__header-arrow`}
          type="button"
          onClick={() => onChangeMonth("prev")}
        >
          <ArrowIcon />
        </button>
        <button
          className={`${mainClass}__header-date`}
          type="button"
          onClick={onBack}
        >{`${date?.format("MMM")} ${date?.year()}`}</button>
        <button
          className={`${mainClass}__header-arrow`}
          type="button"
          onClick={() => onChangeMonth("next")}
        >
          <ArrowIcon />
        </button>
      </div>
      <div className={`${mainClass}__weekdays`}>
        {dayNames.map((day, index) => (
          <div key={index}>{t(day)}</div>
        ))}
      </div>
      <div className={`${mainClass}__list`}>
        {all_days?.map((item, index) => (
          <button
            key={`${item.date}-${index}`}
            className={classnames({
              active: item?.date === selected_date?.format("ll"),
              today: item?.isToday,
            })}
            type="button"
            disabled={item?.disabled}
            onClick={() => onSelect(item?.day)}
          >
            {item?.day}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CalendarDays;
